import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/flowStep/importer/flowStepImporterActions';

export default importerReducers(actions);
